import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfileDevice,
  DeviceProfileVendor,
  CreateDeviceProfileDeviceRequest,
} from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";
import type { CreateDeviceProfileDeviceResponse } from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import DeviceForm from "./DeviceForm";
import deviceProfileStore from "../../stores/DeviceProfileStore";
import { useTitle } from "../helpers";

interface IProps {
  vendor: DeviceProfileVendor;
}

function CreateDevice(props: IProps) {
  useTitle("Network Server", "Device Profiles", "Vendors", props.vendor.getName(), "Add device");
  const navigate = useNavigate();

  const onFinish = (device: DeviceProfileDevice) => {
    device.setVendorId(props.vendor.getId());
    const req = new CreateDeviceProfileDeviceRequest();
    req.setDevice(device);

    deviceProfileStore.createDevice(req, (resp: CreateDeviceProfileDeviceResponse) => {
      navigate(`/device-profiles/vendors/${props.vendor.getId()}/devices/${resp.getId()}/profiles`);
    });
  };

  const initial = new DeviceProfileDevice();
  initial.setVendorId(props.vendor.getId());
  initial.setPublished(true);

  return (
    <Space orientation="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb
            items={[
              { title: "Network Server" },
              { title: "Device Profiles" },
              { title: <Link to="/device-profiles/vendors">Vendors</Link> },
              {
                title: (
                  <Link to={`/device-profiles/vendors/${props.vendor.getId()}/devices`}>{props.vendor.getName()}</Link>
                ),
              },
              { title: "Add device" },
            ]}
          />
        )}
        title="Add device"
      />
      <Card>
        <DeviceForm initialValues={initial} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateDevice;
